import {LightCard} from '@stripe-internal/conversations-ui';
import {ReactNode, ComponentType, FC} from 'react';

type Props = {
  children: ReactNode;
  universalHelpNewDesign?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  CardComp: ComponentType<any>;
};

/**
 * New design shows the LightCard component regardless.
 * It takes a CardComp to show when using the old design.
 */
export const CardForNewDesign: FC<Props> = ({
  children,
  universalHelpNewDesign,
  CardComp,
}) =>
  universalHelpNewDesign ? (
    <LightCard isOuter>{children}</LightCard>
  ) : (
    <CardComp>{children}</CardComp>
  );
